// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3q8cq","title":"Info_title__1Om1f","links":"Info_links__3UQrW","link":"Info_link__2P532","logo":"Info_logo__3zwGY"};